export default function SvgMessage10() {
    return (
      <>
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#00cc00"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M8.5 19H8c-4 0-6-1-6-6V8c0-4 2-6 6-6h8c4 0 6 2 6 6v5c0 4-2 6-6 6h-.5c-.31 0-.61.15-.8.4l-1.5 2c-.66.88-1.74.88-2.4 0l-1.5-2c-.16-.22-.53-.4-.8-.4z"
      ></path>
      <path
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.996 11h.01M11.995 11h.009M7.995 11h.008"
        opacity="0.4"
      ></path>
    </svg>
    </>
  );
}
